import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    CardContent,
    Button,
    Card,
    Grid,
    Typography,
    TextField,
    Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GetItem } from "../utils/storage";
import { StorageKey } from "../constants/constants";

export default function OtpForm() {
    const navigate = useNavigate();
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [storedOtp, setStoredOtp] = useState("");
    const [error, setError] = useState("");
    const inputRefs = useRef([]);

    useEffect(() => {
        async function fetchOtp() {
            const user = await GetItem(StorageKey.USER);
            if (user) {
                setStoredOtp(user.otp);
            }
        }
        fetchOtp();
    }, []);

    const handleChange = (element, index) => {
        if (!/^\d$/.test(element.value) && element.value !== "") return;
        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);
        // Mover el foco al siguiente campo si el dígito actual no está vacío
        if (element.value && index < 5) {
            inputRefs.current[index + 1].focus();
        }
        // Mover el foco al campo anterior si se borra el dígito actual
        if (!element.value && index > 0) {
            inputRefs.current[index - 1].focus();
        }
        // Si todos los campos están completos, hacer el submit automáticamente
        if (newOtp.every((digit) => digit !== "")) {
            handleSubmit(newOtp);
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").trim();
        if (!/^\d{6}$/.test(pasteData)) return;
        const otpArray = pasteData.split("");
        setOtp(otpArray);

        // Enfocar el último campo
        inputRefs.current[5].focus();

        // Hacer el submit automáticamente
        handleSubmit(otpArray);
    };

    const handleSubmit = (enteredOtpArray = otp) => {
        const enteredOtp = enteredOtpArray.join("");
        if (enteredOtp === storedOtp) {
            // OTP correcto, proceder a la siguiente vista
            navigate("/app");
        } else {
            // OTP incorrecto, mostrar error y resetear los campos
            setError("El código OTP es incorrecto. Por favor, inténtalo de nuevo.");
            setOtp(new Array(6).fill(""));
            inputRefs.current[0].focus();
        }
    };

    return (
        <Card sx={{
            width: { xs: '90%', md: '60%', lg: '30%', xl: '25%' },
            margin: 'auto',
            position: 'relative',
            zIndex: 1
        }}>


            <Grid container justifyContent="center" sx={{ my: 5 }}>


                <Box p={2}>
                    <Typography variant="h4" align="center">
                        Ingresa el código OTP
                    </Typography>
                    <Typography variant="body2" align="center">
                        Introduce el código de verificación enviado a su celular
                    </Typography>
                    {error && (
                        <Box mt={2}>
                            <Alert severity="error">{error}</Alert>
                        </Box>
                    )}
                    <Box
                        mt={3}
                        display="flex"
                        justifyContent="center"
                        onPaste={handlePaste}
                    >
                        {otp.map((data, index) => (
                            <TextField
                                key={index}
                                type="text"
                                inputProps={{
                                    maxLength: 1,
                                    style: { textAlign: "center", fontSize: "24px" },
                                }}
                                sx={{ width: "50px", marginRight: "8px" }}
                                value={data}
                                onChange={(e) => handleChange(e.target, index)}
                                onFocus={(e) => e.target.select()}
                                inputRef={(el) => (inputRefs.current[index] = el)}
                            />
                        ))}
                    </Box>
                    <Box mt={3} display="flex" justifyContent="center">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleSubmit()}
                        >
                            Verificar OTP
                        </Button>
                    </Box>
                </Box>

            </Grid>

        </Card>
    );
}
